const state = {
    ready: {
        ausstattung: false,
        kategorien: false
    },
    updating: {
        ausstattung: false,
        kategorien: false,
    },
    ausstattung: [],
    kategorien: [],


}
const getters = {
    ready: (state) => state.ready,
    updating: (state) => state.updating,
    ausstattung: (state) => state.ausstattung,
    kategorien: (state) => state.kategorien,
}
const actions = {
    async unassignToBp(_, relId) {
        try {
            await this._vm.$directus.deleteItem("bauprojekt_ausstattung", relId);
        } catch (error) {
            console.log(error);
            throw "Fehler beim entfernen der Ausstattungszuweisung.";
        }
    },
    async assignToBp(_, payload) {
        try {
            await this._vm.$directus.createItem("bauprojekt_ausstattung", payload);
        } catch (error) {
            console.log(error);
            throw "Fehler beim Zuweisen des Ausstattung";
        }
    },
    async getAusstattungBauprojekt(_, bpId) {
        const fields = {
            fields: "*.*.*",
            filter: {
                bauprojekt_id: bpId
            }
        }
        try {
            const response = await this._vm.$directus.getItems("bauprojekt_ausstattung", fields);
            return response.data;
        } catch (error) {
            console.log(error);
            throw "Fehler beim Laden der Ausstattungen zum Bauprojekt."
        }
    },
    async deleteAusstattung(_, ausId) {
        try {
            await this._vm.$directus.deleteItem("ausstattung", ausId);
        } catch (error) {
            console.log(error);
            throw "Fehler beim Entfernen der Ausstattung";
        }
    },
    async createAusstattung(_, payload) {
        try {
            this._vm.$directus.createItem("ausstattung", payload);
        } catch (error) {
            console.log(error);
            throw "Fehler beim Erstellen der Ausstattung";
        }
    },
    async getKategorien({
        commit
    }) {
        try {
            const fields = {
                fields: "*.*"
            }
            const response = await this._vm.$directus.getItems("ausstattung_kategorie", fields);
            commit("setKategorien", response.data);
            commit("setReadyState", "kategorien");
        } catch (error) {
            console.log(error);
            throw "Fehler beim Laden der Ausstattungskategorien";
        }
    },
    async getAusstattung({
        commit
    }) {
        try {
            const fields = {
                fields: "*.*"
            }
            const response = await this._vm.$directus.getItems("ausstattung", fields);
            commit("setAusstattung", response.data);
            commit("setReadyState", "ausstattung")
        } catch (error) {
            console.log(error);
            throw "Fehler beim Laden der Ausstattungen.";
        }
    },
    async createCategory({ dispatch }, payload) {
        try {
            await this._vm.$directus.createItem("ausstattung_kategorie", payload);
            await dispatch("getKategorien");
        } catch (error) {
            console.log(error);
            throw "Fehler beim Erstellen der Kategorie";
        }
    },
    async deleteCategory({ dispatch }, itemId) {
        try {
            await this._vm.$directus.deleteItem("ausstattung_kategorie", itemId);
            await dispatch("getKategorien");
        } catch (error) {
            console.log(error);
            throw "Fehler beim Entfernen der Kategorie"
        }
    },
}
const mutations = {
    setKategorien: (state, kategorien) => state.kategorien = kategorien,
    setAusstattung: (state, ausstattung) => state.ausstattung = ausstattung,
    setReadyState: (state, context) => {
        switch (context) {
            case "kategorien":
                state.ready.kategorien = true;
                break;
            case "ausstattung":
                state.ready.ausstattung = true;
        }
    },
    unsetReadyState: (state, context) => {
        switch (context) {
            case "kategorien":
                state.ready.kategorien = false;
                break;
            case "ausstattung":
                state.ready.ausstattung = false;
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};